<app-bottom-sheet #sheet ariaLabel="عدم دسترسی انجام معاملات">
	<ng-template #body>
		<ui-empty-state
			class="py-4"
			data-cy="commodity-access-denied-text"
			variant="error"
			iconName="blocked"
			title="عدم دسترسی انجام معاملات"
			description="مشتری گرامی برای انجام معاملات در این سامانه نیازمند دریافت کد بورس کالا می‌باشید." />
	</ng-template>

	<ng-template #footer>
		<div class="flex w-full items-center gap-2 py-4" data-cy="commodity-access-denied-actions">
			<ui-button
				type="button"
				class="min-w-0 flex-1"
				variant="mofid"
				size="lg"
				extraButtonClasses="w-full"
				data-cy="commodity-access-denied-register"
				label="دریافت کد بورس کالا"
				(clicked)="onRegister()" />
			<ui-button
				type="button"
				class="shrink-0 grow-0"
				variant="mute"
				model="outline"
				size="lg"
				data-cy="commodity-access-denied-dismiss"
				label="انصراف"
				(clicked)="close()" />
		</div>
	</ng-template>
</app-bottom-sheet>
